import { combineReducers, Reducer } from 'redux';
import { reducer as invoiceReducer } from 'b2b-apps/shop/myAccount/invoices/redux/invoice/reducer';
import { reducer as invoicesReducer } from 'b2b-apps/shop/myAccount/invoices/redux/invoices/reducer';
import { reducer as invoicesSearchReducer } from 'b2b-apps/shop/myAccount/invoices/redux/invoicesSearch/reducer';
import { InvoicesAction, InvoicesState } from './types';

const reducer: Reducer<InvoicesState, InvoicesAction> = combineReducers({
  invoices: invoicesReducer,
  invoice: invoiceReducer,
  invoicesSearch: invoicesSearchReducer,
});

export { reducer };
